<template>
  <main id="teachings" class="content">
    <h1>Teachings</h1>
    <section>
      <p>In recent years, I have taught various courses in higher education:</p>
      <ul>
        <li>
          <strong>Technologies
            Web</strong> <small>(2019-2020, 2020-2021, 2021-2022, 2022-2023)</small>
          <br>LP ESSIG (IUT2 / Univ. Grenoble Alpes)
        </li>
        <li>
          <strong>Python pour
            QGIS</strong> <small>(2018-2019, 2019-2020, 2020-2021, 2021-2022, 2022-2023)</small>
          <br>LP ESSIG (IUT2 / Univ. Grenoble Alpes)
        </li>
        <li>
          <strong>Outils de Communication Territoriale
            : cartographie thématique</strong> <small>(2019-2020, 2020-2021)</small>
          <br>M1 IDT2 (IUGA / Univ. Grenoble Alpes)
        </li>
        <li>
          <strong>Outils de l'Urbanisme :
            Introduction aux SIG</strong> <small>(2018-2019, 2019-2020)</small>
          <br>M1 Urbanisme (IUGA / Univ. Grenoble Alpes)
        </li>
        <li>
          <strong>Introduction aux SIG</strong> <small>(2020-2021)</small>
          <br>3ème année ISI et Mastere BigData (ENSIMAG / Grenoble INP)
        </li>
        <li>
          <strong>Des données à la cartographie :
            cartographie thématique</strong> <small>(2021-2022)</small>
          <br>M1 GAED-GEOMAS / M1 GAED-GEOPOESICE (IUGA / Univ. Grenoble Alpes)
        </li>
        <li>
          <strong>Introduction aux technologies Web</strong> <small>(2022-2023)</small>
          <br>M1 Management des Systèmes d'Information (IAE / Univ. Grenoble Alpes)
        </li>
        <li>
          <strong>Systèmes d'Information Géographique</strong> <small>(2022-2023)</small>
          <br>LP Programmation Avancée
          (IUT de Bayonne et du Pays Basque / Univ. Pau et Pays de l'Adour)
        </li>
        <li>
          <strong>Programmation
            Web pour la visualisation</strong> <small>(2023-2024, 2024-2025, 2025-2026)</small>
          <br>3ème année BUT Science des Données
          (IUT2 / Univ. Grenoble Alpes)
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
export default {
  name: 'Teachings',
};
</script>
